module.exports = __webpack_public_path__ + "static/media/icon-box2.1ea2a9c3.svg";